export function convertDate(date, timezone) {
    let dateObj = date instanceof Date ? date : new Date(date);
    if (isNaN(dateObj.getTime())) {
      return 'Invalid Date';
    }
    if (!timezone || timezone === 'undefined') {
      timezone = 'Europe/Amsterdam';
    }
    try{
      return new Intl.DateTimeFormat('it-IT', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false,
        timeZone: timezone,
      }).format(dateObj);
    }
    catch{
      return date
    }
  }

export const redirectMap = {
  1: { name: "Critical", url: "critical" },
  0: { name: "High", url: "high" },
  2: { name: "Alert", url: "alert" },
  3: { name: "Movements", url: "movements" },
  4: { name: "Threat Intelligence", url: "threat-intelligence" },
}